import { render, staticRenderFns } from "./MajorSelector.vue?vue&type=template&id=7c0a7b75&scoped=true&"
import script from "./MajorSelector.vue?vue&type=script&lang=js&"
export * from "./MajorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a7b75",
  null
  
)

export default component.exports